import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-htc-ltc-rec--form',
  templateUrl: './htc-ltc-rec--form.component.html',
  styleUrls: ['./htc-ltc-rec--form.component.css']
})
export class HtcLtcRecFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/employee-claims/htc-ltc-rec/htc-ltc-rec--form/htc-ltc-rec--form.component.ts